import useAccountAddresses from "../data/useAccountAddresses";

export function useAddressLookup(accountId: string) {
  const { accountAddresses } = useAccountAddresses(accountId, "useAddressLookup");

  const addressLookup = (addressId: string) =>
    accountAddresses.data?.data?.find((a) => a.id === addressId);

  return {
    addressLookup,
    isLoading: accountAddresses.isLoading,
  };
}
